import { MakeModelKeywordSearch } from '../../../../features/MakeModelKeywordSearch/MakeModelKeywordSearch';
import Select from './subcomponents/FixedSelect';

import { useMotorsSearch } from './MotorSearch.hook';

import { MotorSearchProps } from './MotorSearch.typed';
import {
  DoneDealMotorEntryPoint,
  HomePageSearchButton,
} from '../../Layouts/HomePageSearchManager.styled';
import { formatNumber } from '../../../../helpers/formatting';
import { DisplayContainer } from '../../../../components/Support/DisplayContainer/DisplayContainer';
import { DoneDealCertifiedTrustedDealerLink } from '../../components/DoneDealCertifiedTrustedDealerLink/DoneDealCertifiedTrustedDealerLink';
import { Wrapper, MinMaxSelectWrapper } from './MotorSearch.styled';

export const MotorSearch = (props: MotorSearchProps) => {
  const { makes, yearOptions, priceOptions, initialAdCount, domain } = props;

  const {
    onSelectOption,
    selectedFilters,
    setSelectedFilters,
    adsCount,
    keywordSearchValue,
    handleSearch,
  } = useMotorsSearch({
    initialAdCount,
    domain,
  });

  const modalDisplayConfig = {
    small: 'block',
    medium: 'none',
    large: 'none',
  };
  const dropdownDisplayConfig = {
    small: 'none',
    medium: 'block',
    large: 'block',
  };

  return (
    <>
      <Wrapper>
        <MakeModelKeywordSearch
          value={keywordSearchValue}
          onSelectOption={onSelectOption}
          modalDisplayConfig={modalDisplayConfig}
          dropdownDisplayConfig={dropdownDisplayConfig}
          makes={makes}
          minPrice={selectedFilters.price.min ?? undefined}
          maxPrice={selectedFilters.price.max ?? undefined}
          minYear={selectedFilters.year.min ?? undefined}
          maxYear={selectedFilters.year.max ?? undefined}
        />
        <MinMaxSelectWrapper>
          <Select
            id="year_from"
            name="year_from"
            value={selectedFilters.year.min}
            placeholder={false}
            placeholderAsOption={true}
            options={restrictOptions(yearOptions.min, {
              max: selectedFilters.year.max,
            })}
            onChange={(value) => {
              setSelectedFilters((current) => ({
                ...current,
                year: {
                  ...current.year,
                  min: value,
                },
              }));
            }}
            heightVariant="LARGE"
            willUseSubText={false}
            aria-label="Year From"
          />
          <Select
            id="year_to"
            name="year_to"
            value={selectedFilters.year.max}
            placeholder={false}
            placeholderAsOption={true}
            options={restrictOptions(yearOptions.max, {
              min: selectedFilters.year.min,
            })}
            onChange={(value) => {
              setSelectedFilters((current) => ({
                ...current,
                year: {
                  ...current.year,
                  max: value,
                },
              }));
            }}
            heightVariant="LARGE"
            willUseSubText={false}
            aria-label="Year To"
          />
        </MinMaxSelectWrapper>
        <MinMaxSelectWrapper>
          <Select
            id="price_from"
            name="price_from"
            value={selectedFilters.price.min}
            placeholder={false}
            placeholderAsOption={true}
            options={restrictOptions(priceOptions.min, {
              max: selectedFilters.price.max,
            })}
            onChange={(value) => {
              setSelectedFilters((current) => ({
                ...current,
                price: {
                  ...current.price,
                  min: value,
                },
              }));
            }}
            heightVariant="LARGE"
            willUseSubText={false}
            aria-label="Price From"
          />
          <Select
            id="price_to"
            name="price_to"
            value={selectedFilters.price.max}
            placeholder={false}
            placeholderAsOption={true}
            options={restrictOptions(priceOptions.max, {
              min: selectedFilters.price.min,
            })}
            onChange={(value) => {
              setSelectedFilters((current) => ({
                ...current,
                price: {
                  ...current.price,
                  max: value,
                },
              }));
            }}
            heightVariant="LARGE"
            willUseSubText={false}
            aria-label="Price To"
          />
        </MinMaxSelectWrapper>
      </Wrapper>
      <HomePageSearchButton
        size="LARGE"
        onClick={handleSearch}
        data-testid="homepage-search-button"
      >
        {`Search ${formatNumber(adsCount)} Cars`}
      </HomePageSearchButton>
      <DisplayContainer
        config={{ small: 'block', medium: 'block', large: 'none' }}
      >
        <DoneDealMotorEntryPoint>
          <DoneDealCertifiedTrustedDealerLink />
        </DoneDealMotorEntryPoint>
      </DisplayContainer>
    </>
  );
};

function restrictOptions(
  options: Array<{
    value: string | null;
    label: string;
  }>,
  constraint: {
    min?: string | null;
    max?: string | null;
  },
) {
  const min = constraint.min ? Number.parseInt(constraint.min) : -Infinity;
  const max = constraint.max ? Number.parseInt(constraint.max) : Infinity;
  return options.filter((option) => {
    if (option.value === null) return true;
    const value = Number.parseInt(option.value);
    return value >= min && value <= max;
  });
}
